import { WithStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./MyOrdersView.styles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../auth/AuthProvider";
import * as OrderAction from "../../stores/orders/OrderAction";
import { useDispatch, useSelector } from "react-redux";
import { IUniversalTableColumn, IUniversalTableData } from "../components/UniversalTable/interfaces";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import OrderModel from "../../models/order/OrderModel";
import UniversalTable from "../components/UniversalTable/UniversalTable";
import { Breadcrumbs } from "../components/Breadcrumbs/Breadcrumbs";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import { fromToString } from "../../utilities/dateTimeUtils";

export interface IMyOrdersViewProps extends WithStyles<typeof styles> {
}

const MyOrdersViewPure: React.FunctionComponent<IMyOrdersViewProps> = ({classes}: IMyOrdersViewProps) => {
    const history = useHistory();
    const {t} = useTranslation();

    const onRowClick = row => {
        let path = "my-orders/" + orders[row].orderId;
        history.push(path);
    };

    const dispatch = useDispatch();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;

    useEffect(() => {
        dispatch(OrderAction.requestUserOrders(userId));
    }, [dispatch, userId]);

    const productsOverview = useSelector(state => state.products);
    const ordersFromState = useSelector(state => state.orders?.currentUser);
    const isRequesting = useSelector(state => selectRequesting(state, [OrderAction.REQUEST_USER_ORDERS_FINISHED]));
    let orders: IUniversalTableData;

    if (ordersFromState) {
        orders = Object.values(ordersFromState)?.filter(
            (order: OrderModel) => order.state !== "New" && order.state !== "Locked"
        ).map((order: OrderModel) => ({
            orderId: order.orderId,
            created: order.created,
            totalPrice: order.totalPrice,
            state: order.state,
            timeRange: order.items.length === 1 ? fromToString(order.items[0]["from"], order.items[0]["to"]) : "",
            items: order.items
        }));
    }

    const columns: IUniversalTableColumn[] = [
        {
            type: "link",
            title: t("general.orderNo"),
            field: "orderId",
            onClick: index => onRowClick(index)
        },
        {
            type: "products",
            title: "Products",
            field: "items",
            allProducts: productsOverview.products
        },
        {
            type: "text",
            title: "Time range",
            field: "timeRange"
        },
        {
            type: "date",
            title: t("general.createdOn"),
            field: "created"
        },
        {
            type: "price",
            title: t("general.totalAmountVat"),
            field: "totalPrice"
        },
        {
            type: "text",
            title: t("general.status"),
            field: "state"
        }
    ];

    return (
        <CenteredContainer>
            <Breadcrumbs
                items={[
                    {title: t("manageAccount.myAccount"), href: "/my-account"},
                    {title: t("general.myOrders"), href: "/my-account/my-orders"}
                ]}
            />
            <div className={classes.title}>
                <Typography variant="h3">{t("general.myOrders")}</Typography>
            </div>
            <UniversalTable columns={columns} data={orders} isLoading={isRequesting} searchable />
        </CenteredContainer>
    );
};

export const MyOrdersView = withStyles(styles)(MyOrdersViewPure);
